import type { PartSvgProps } from './types'

export default function UpperReceiverSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 160,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 160 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Upper body */}
      <path d="M 12 20 L 148 20 L 154 28 L 154 58 L 148 66 L 12 66 L 8 58 L 8 28 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Ejection port */}
      <rect x="40" y="36" width="36" height="20" rx="2"
            fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Dust cover suggestion (diagonal hinge line) */}
      <line x1="40" y1="36" x2="76" y2="56"
            stroke={stroke} strokeWidth="0.8" strokeDasharray="3 3" />
      {/* Forward assist circle */}
      <circle cx="100" cy="43" r="8" fill={fill} stroke={stroke} strokeWidth="1.2" />
      <circle cx="100" cy="43" r="3" fill="none" stroke={accent} strokeWidth="1" />
      {/* Barrel extension socket */}
      <rect x="8" y="30" width="12" height="20" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1" />
      {/* Charging handle slot */}
      <rect x="126" y="20" width="20" height="10" rx="1"
            fill="none" stroke={stroke} strokeWidth="1" />
    </svg>
  )
}
